import React, { Fragment } from "react";
import cx from "classnames";

import HeaderLogo from "../AppSidebar/HeaderLogo";

import { connect } from "react-redux";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";

//CUSTOM COMPONENTS
import Options from "./Options";
import Targets from "./Targets";
import Redirects from "./Redirects";

import UserBox from "./UserBox";



const AppHeader = props => {
  let {
    headerBackgroundColor,
    enableMobileMenuSmall,
    enableHeaderShadow
  } = props;
  return (
    <Fragment>
      <ReactCSSTransitionGroup
        component="div"
        className={cx("app-header", "bg-royal", "header-text-light", {
          "header-shadow": enableHeaderShadow
        })}
        transitionName="HeaderAnimation"
        transitionAppear={true}
        transitionAppearTimeout={1500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <HeaderLogo />

        <div
          className={cx("app-header__content", {
            "header-mobile-open": enableMobileMenuSmall
          })}
        >
          <div className="app-header-left"></div>
          <div className="app-header-right">
            <Redirects />
            {/* <Targets /> */}
            {/* <Options /> */}
            <UserBox />
          </div>
        </div>
      </ReactCSSTransitionGroup>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
